export default "__VITE_ASSET__BqTFlR_J__"